import React from 'react';

/**
 * Displays the sender information and message status
 * @param {Object} props - Component props
 * @param {string} props.role - Message role (user, system, or assistant)
 * @param {string} props.firstName - User's first name
 * @param {string} props.lastName - User's last name
 * @param {string} props.className - Additional CSS classes
 */
const MessageHeader = ({ role, firstName, lastName, className = '' }) => {
  // Determine the display text based on the role
  const getSenderText = () => {
    switch (role) {
      case 'user':
        return `${firstName} ${lastName}: `;
      case 'system':
        return 'System: ';
      case 'assistant':
      default:
        return 'AI:';
    }
  };

  return (
    <div className={`mb-2 fw-bold text-capitalize ${className}`}>
      {getSenderText()}
    </div>
  );
};

export default MessageHeader;
